import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { fmtDate, fmtHours, monthRange } from '../utils/helpers';

export default function ReportInstructor() {
  const [data,         setData]         = useState(null);
  const [instructors,  setInstructors]  = useState([]);
  const [filters,      setFilters]      = useState(monthRange());
  const [loading,      setLoading]      = useState(false);

  useEffect(() => {
    api.instructors.list().then(setInstructors).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [filters]);

  async function load() {
    setLoading(true);
    try { setData(await api.reports.instructorTime(filters)); } catch {}
    setLoading(false);
  }

  function setF(k, v) { setFilters(f => ({ ...f, [k]: v || undefined })); }

  return (
    <div>
      <div className="section-title">Instructor Time Report</div>

      <div className="filter-bar">
        <div className="form-group">
          <label>From</label>
          <input type="date" value={filters.from || ''} onChange={e => setF('from', e.target.value)} />
        </div>
        <div className="form-group">
          <label>To</label>
          <input type="date" value={filters.to || ''} onChange={e => setF('to', e.target.value)} />
        </div>
        <div className="form-group">
          <label>Instructor</label>
          <select value={filters.instructor_id || ''} onChange={e => setF('instructor_id', e.target.value)}>
            <option value="">All Instructors</option>
            {instructors.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
          </select>
        </div>
        <button className="btn btn-secondary btn-sm" onClick={() => setFilters(monthRange())}>This Month</button>
        <button className="btn btn-secondary btn-sm" onClick={() => {
          const y = new Date().getFullYear();
          setFilters({ from: `${y}-01-01`, to: `${y}-12-31` });
        }}>This Year</button>
        <button className="btn btn-primary btn-sm" onClick={() => window.print()}>Print / PDF</button>
      </div>

      {loading && <div className="empty">Loading...</div>}

      {data && (
        <>
          <div className="card">
            <div className="card-header"><h2>Summary by Instructor</h2></div>
            <div className="card-body" style={{ padding: 0 }}>
              {data.summary.length === 0 ? (
                <div className="empty">No data for selected period</div>
              ) : (
                <div className="table-wrap">
                  <table>
                    <thead>
                      <tr>
                        <th>Instructor</th>
                        <th>ID</th>
                        <th>Sessions</th>
                        <th>Lab Hours</th>
                        <th>Sim Hours</th>
                        <th>First Session</th>
                        <th>Last Session</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.summary.map((r, i) => (
                        <tr key={i}>
                          <td style={{fontWeight:600}}>{r.instructor_name}</td>
                          <td>{r.instructor_code}</td>
                          <td>{r.session_count}</td>
                          <td style={{fontWeight:700}}>{fmtHours(r.total_lab_hours)}</td>
                          <td style={{fontWeight:700, color:'#1A2E5A'}}>{fmtHours(r.total_sim_hours)}</td>
                          <td>{fmtDate(r.first_session)}</td>
                          <td>{fmtDate(r.last_session)}</td>
                        </tr>
                      ))}
                      <tr className="total-row" style={{background:'#f0f4fa'}}>
                        <td colSpan={2} style={{fontWeight:700}}>TOTAL</td>
                        <td style={{fontWeight:700}}>{data.summary.reduce((a,r) => a + r.session_count, 0)}</td>
                        <td style={{fontWeight:700}}>{fmtHours(data.summary.reduce((a,r) => a + r.total_lab_hours, 0))}</td>
                        <td style={{fontWeight:700, color:'#1A2E5A'}}>{fmtHours(data.summary.reduce((a,r) => a + r.total_sim_hours, 0))}</td>
                        <td colSpan={2}></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          {data.detail.length > 0 && (
            <div className="card">
              <div className="card-header"><h2>Session Detail</h2></div>
              <div className="card-body" style={{ padding: 0 }}>
                <div className="table-wrap">
                  <table>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Instructor</th>
                        <th>PIC</th>
                        <th>SIC</th>
                        <th>Training Type</th>
                        <th>Lab Start</th>
                        <th>Lab Stop</th>
                        <th>Lab Time</th>
                        <th>Hobbs Start</th>
                        <th>Hobbs Stop</th>
                        <th>Sim Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.detail.map((r, i) => (
                        <tr key={i}>
                          <td>{fmtDate(r.date)}</td>
                          <td>{r.instructor_name}</td>
                          <td>{r.pic_name || '—'}{r.single_pilot ? <span style={{fontSize:11,color:'#888',marginLeft:4}}>(solo)</span> : null}</td>
                          <td>{r.sic_name || '—'}</td>
                          <td><span className="badge badge-type">{r.training_type}</span></td>
                          <td>{r.start_time}</td>
                          <td>{r.end_time}</td>
                          <td style={{fontWeight:600}}>{fmtHours(r.lab_time)}</td>
                          <td>{r.hobbs_start}</td>
                          <td>{r.hobbs_stop}</td>
                          <td style={{fontWeight:600, color:'#1A2E5A'}}>{fmtHours(r.sim_time)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
